<template>
    <sub-menu :links="links" :active="active"></sub-menu>
</template>

<script>
    import Meta from '@/mixins/Meta'
    import SubMenu from '@/components/Layout/SubMenu'

    export default {
        components: {SubMenu},

        mixins: [Meta],

        props: ['user'],

        computed: {
            links() {
                return [
                    {
                        id: 'dashboard',
                        url: '/users/' + this.user.id,
                        text: 'My Dashboard'
                    },
                    {
                        id: 'targets',
                        url: '/users/' + this.user.id + '/targets',
                        text: 'Targets'
                    },
                    {
                        id: 'logins',
                        url: '/users/' + this.user.id + '/logins',
                        text: 'Logins'
                    },
                    {
                        id: 'edit',
                        url: '/users/' + this.user.id + '/edit',
                        text: 'Edit'
                    }
                ]
            },

            active() {
                return this.getMeta('subsection')
            }
        }
    }
</script>
